import TypeBasculeDetailController from './type.bascules.detail.controller';

export default {
    template: require('./type.bascules.detail.html'),
    controller: TypeBasculeDetailController
};
